import { Linkedin, MessageCircle, Globe } from "lucide-react";
import { ASSETS, COMPANY, NAV_LINKS } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#050F1F] pt-20 pb-10">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img
            src={ASSETS.logo}
            alt={`${COMPANY.short} logo`}
            data-testid="footer-logo"
            className="h-12 w-auto object-contain"
          />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-400">
            {COMPANY.legal} — {COMPANY.name}. {COMPANY.certification}.
          </p>
          <p className="mt-4 font-display text-sm font-semibold uppercase tracking-[0.2em] text-[#22D3EE]">
            {COMPANY.tagline}
          </p>
          <div className="mt-7 flex items-center gap-3">
            <a
              href={COMPANY.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-linkedin"
              className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-slate-300 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
            >
              <Linkedin size={16} />
            </a>
            <a
              href={COMPANY.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              data-testid="footer-whatsapp"
              className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-slate-300 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
            >
              <MessageCircle size={16} />
            </a>
            <a
              href={`https://${COMPANY.website}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Website"
              data-testid="footer-website"
              className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-slate-300 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
            >
              <Globe size={16} />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-display text-xs font-bold uppercase tracking-[0.22em] text-white">
            Quick Links
          </h4>
          <div className="mt-6 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`footer-link-${l.href.slice(1)}`}
                className="text-sm text-slate-400 hover:text-[#D4AF37] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-4">
          <h4 className="font-display text-xs font-bold uppercase tracking-[0.22em] text-white">
            Get In Touch
          </h4>
          <div className="mt-6 space-y-4 text-sm text-slate-400">
            <p>
              <span className="block text-[11px] uppercase tracking-[0.18em] text-slate-500">
                Register Office
              </span>
              {COMPANY.registeredOffice}
            </p>
            <p>
              <span className="block text-[11px] uppercase tracking-[0.18em] text-slate-500">
                Corporate Office
              </span>
              {COMPANY.corporateOffice}
            </p>
            <p>
              <span className="block text-[11px] uppercase tracking-[0.18em] text-slate-500">
                Mob. No.
              </span>
              {COMPANY.phones.join(" / ")}
            </p>
            <div className="flex flex-col gap-1">
              {COMPANY.emails.map((e) => (
                <a
                  key={e}
                  href={`mailto:${e}`}
                  className="break-all hover:text-[#D4AF37] transition-colors duration-300"
                >
                  {e}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-7 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.
        </p>
        <a
          href={`https://${COMPANY.website}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-slate-500 hover:text-[#D4AF37] transition-colors duration-300"
        >
          {COMPANY.website}
        </a>
      </div>
    </div>
  </footer>
);
